import registerServiceWorker from '@Infra/ServiceWorker/registerServiceWorker';
import Application from '@UI/Application';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@verclam/ui-kit/tokens.css';
import '@fontsource-variable/bricolage-grotesque/opsz.css';
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/400-italic.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

const container = document.getElementById('root');

if (container === null) {
	throw new Error('Le point de montage #root est absent de la page.');
}

createRoot(container).render(
	<StrictMode>
		<BrowserRouter>
			<Application />
		</BrowserRouter>
	</StrictMode>,
);

registerServiceWorker();
